import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-apple",
  "use": "icon-apple-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-apple\">\n  <path d=\"m0 0h14v44h-14z\" fill=\"none\" />\n  <path d=\"M 12.305 4.756 C 12.226 4.819 10.824 5.609 10.824 7.366 C 10.824 9.399 12.607 10.117 12.661 10.135 C 12.652 10.179 12.377 11.121 11.72 12.078 C 11.135 12.921 10.522 13.764 9.591 13.764 C 8.659 13.764 8.418 13.223 7.345 13.223 C 6.297 13.223 5.925 13.783 5.073 13.783 C 4.22 13.783 3.626 13.001 2.943 12.044 C 2.154 10.916 1.514 9.168 1.514 7.508 C 1.514 4.846 3.245 3.434 4.948 3.434 C 5.854 3.434 6.608 4.028 7.176 4.028 C 7.717 4.028 8.56 3.399 9.59 3.399 C 9.981 3.399 11.383 3.435 12.305 4.756 Z M 9.102 2.273 C 9.528 1.767 9.829 1.065 9.829 0.364 C 9.829 0.267 9.821 0.169 9.802 0.089 C 9.111 0.116 8.285 0.55 7.789 1.127 C 7.398 1.572 7.034 2.273 7.034 2.982 C 7.034 3.089 7.052 3.196 7.061 3.231 C 7.105 3.239 7.176 3.249 7.247 3.249 C 7.868 3.249 8.649 2.831 9.101 2.273 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/apple/apple.svg
// module id = EF+K
// module chunks = 62